import { Component, OnInit } from '@angular/core';
import { FormArray, NgForm, Validators } from '@angular/forms';
import _ from 'lodash';
import moment from 'moment';
import { BaseDialogComponent } from '../base-dialog/base-dialog.component';
import { LoggerService } from '../../../services/logger.service';

@Component({
  selector: 'app-misc-service-deductions-entity',
  templateUrl: './misc-service-deductions-entity.component.html',
  styleUrls: ['./misc-service-deductions-entity.component.css']
})
export class MiscServiceDeductionsEntityComponent extends BaseDialogComponent implements OnInit {

  override eckType = "deductions";
  override bundle = "miscservicededuction";
  override entityId = this._injectedDialogData['data']['EntityID'];

  weekNumber;
  yearNumber;

  /**
   * True when this deduction is (or is being created) linked to a misc_event.
   * Linked deductions derive their title from the event instead of collecting
   * a free-text event name; legacy deductions keep the manual field.
   */
  get isEventLinked(): boolean {
    const fieldsData = this._injectedDialogData['data']?.fieldsData;
    if (fieldsData?.misc_event && fieldsData?.misc_event_title) {
      return true;
    }
    // Edit mode: linkage comes from the loaded entity.
    const raw = this.entityData?.field_misc_event;
    return !!(raw?.id ?? raw?.[0]?.target_id ?? raw?.target_id ?? (typeof raw === 'object' ? null : raw));
  }

  override ngOnInit(): void {
    LoggerService.log("this._injectedDialogData['data']", this._injectedDialogData['data'])
    this.initActionType = this._injectedDialogData['data']['action'];
    this.actionType = this._injectedDialogData['data']['action'];

    // Event-linked deductions inherit the event's name as their title, so the
    // stored (required) title stays populated for the report table and print
    // flow without staff re-typing it.
    const linkedEventTitle = this._injectedDialogData['data']?.fieldsData?.misc_event
      ? this._injectedDialogData['data']?.fieldsData?.misc_event_title ?? null
      : null;

    let formGroup = {
      title: [linkedEventTitle, Validators.required],
      field_event_expenses: [null, Validators.required],
      field_transportation_cost: [null, Validators.required],
      field_week_report_number: [this._injectedDialogData['data']?.fieldsData?.week, Validators.required],
      field_year_report_number: [this._injectedDialogData['data']?.fieldsData?.year, Validators.required],
      // Event-mode deductions reference the misc_event occurrence; legacy
      // deductions leave it null and keep matching by week/year.
      field_misc_event: [this._injectedDialogData['data']?.fieldsData?.misc_event ?? null],
    }

    let formGroupEdit;

    formGroupEdit = {
      ...formGroup,
    }

    this.miscServiceDeductionsFormGroup = this._formBuilder.group(formGroupEdit);
  }

  onSubmitMiscDeduction(f: NgForm, drop = false) {
    this.displayProgressSpinner(true);
    LoggerService.log('onSubmitPayment called...');

    LoggerService.log('f.value', f.value);

    this.onSubmit(this.miscServiceDeductionsFormGroup);
  }
}
